__turbopack_context__.v({
  "listingCard": "listing-card-module-scss-module__jeqNxG__listingCard",
  "listingCard__withoutBorder": "listing-card-module-scss-module__jeqNxG__listingCard__withoutBorder",
});
